import SimplePage from "@/components/layout/SimplePage";
import RichHtml from "@/components/RichHtml";
import { useContent } from "@/hooks/useContent";

const FALLBACK = `
  <p>The Sisterhood of Temple Israel of Brevard is a warm, multigenerational community of women who gather to
     study, celebrate, support one another, and serve our temple family. Membership is open to all women of the
     congregation.</p>
  <h2>What Sisterhood Does</h2>
  <ul>
    <li>Hosts oneg Shabbat receptions throughout the year</li>
    <li>Coordinates the Mahjong group and other social gatherings</li>
    <li>Sponsors educational programs, book clubs, and guest speakers</li>
    <li>Supports the religious school with hands-on volunteering</li>
    <li>Organizes fundraisers for the temple and for tzedakah causes</li>
  </ul>
  <h2>Join Us</h2>
  <p>To join or learn more, contact the temple office at
     <a href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a> or call (321) 631-9494.</p>
`;

export default function Sisterhood() {
  const { body } = useContent("sisterhood.body", FALLBACK);
  return (
    <SimplePage
      title="Sisterhood"
      eyebrow="Community"
      subtitle="A vibrant group of women who learn, give, and grow together at TIOB."
      path="/about/sisterhood"
      ctaLabel="Join Sisterhood"
    >
      <RichHtml html={body} fallback={<div dangerouslySetInnerHTML={{ __html: FALLBACK }} />} />
    </SimplePage>
  );
}
